import { render, staticRenderFns } from "./SchedulePage.vue?vue&type=template&id=2c461a97&scoped=true&"
import script from "./SchedulePage.vue?vue&type=script&lang=js&"
export * from "./SchedulePage.vue?vue&type=script&lang=js&"
import style0 from "./SchedulePage.vue?vue&type=style&index=0&id=2c461a97&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c461a97",
  null
  
)

export default component.exports